const GalleryDetails = [


    {
      id: 1,
      title: "Minimal Design Interior",
      price: 109.95,
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
      category: "Circle Mirror Room",
      image: "/assets/images/trending-item-01.jpg",
      isInCart: false,
      rate: 3.9,
      count: 120,
    },
    {
      id: 2,
      title: "Minimal Design Exterior",
      price: 22.3,
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
      category: "Exterior Design",
      image: "/assets/images/pexels5.jpg",
      isIncart: false,
      rate: 4.1,
      count: 259,
    },

    {
        id: 3,
        title: "Bedroom Design Interiorr",
        price: 22.3,
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        category: "Bedroom Design",
        image: "/assets/images/trending-item-02.jpg",
        isIncart: false,
        rate: 4.1,
        count: 259,
    },

    {
        id: 4,
        title: "Minimal Bungalow Interior",
        price: 22.3,
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        category: "Little Bungalow",
        image: "/assets/images/trending-item-04.jpg",
        isIncart: false,
        rate: 4.1,
        count: 259,
    },

    {
        id: 5,
        title: "Tea Table Design",
        price: 22.3,
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        category: "Tea Table Interior",
        image: "/assets/images/trending-item-05.jpg",
        isIncart: false,
        rate: 4.1,
        count: 259,
    },

    {
        id: 6,
        title: "Interior Bed Design",
        price: 22.3,
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        category: "Minimal Bedroom Interior",
        image: "/assets/images/trending-item-06.jpg",
        isIncart: false,
        rate: 4.1,
        count: 259,
    },

    {
        id: 7,
        title: "White Theme Bedroom",
        price: 22.3,
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        category: "White Theme Interior",
        image: "/assets/images/trending-item-07.jpg",
        isIncart: false,
        rate: 4.1,
        count: 259,
    },

    {
        id: 8,
        title: "Specific Interior Design",
        price: 22.3,
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        category: "Specific Design Interior",
        image: "/assets/images/trending-item-08.jpg",
        isIncart: false,
        rate: 4.1,
        count: 259,
    },

    {
        id: 9,
        title: "Another Interior Design",
        price: 22.3,
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        category: "Minimal Design Interior",
        image: "/assets/images/pexels4.jpg",
        isIncart: false,
        rate: 4.1,
        count: 259,
    },

    {
        id: 10,
        title: "Modern Chair Interior",
        price: 22.3,
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        category: "Modern Chair",
        image: "/assets/images/pexels7.jpg",
        isIncart: false,
        rate: 4.1,
        count: 259,
    },

    {
        id: 11,
        title: "Minimal Exterior Decor",
        price: 22.3,
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        category: "Exterior Decor",
        image: "/assets/images/trending-item-04.jpg",
        isIncart: false,
        rate: 4.1,
        count: 259,
    },

    {
        id: 12,
        title: "Glass Table Design",
        price: 22.3,
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
        category: "Glass Table Design",
        image: "/assets/images/trending-item-05.jpg",
        isIncart: false,
        rate: 4.1,
        count: 259,
    },
];

export default GalleryDetails;
